import { routeNames } from '@/router/routeNames'

import type { RouteRecordRaw } from 'vue-router'

export const unauthorizedRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: routeNames.Login,
    meta: { title: 'common.route.login' },
    component: () => import('@/views/LoginView.vue'),
  },
  {
    path: '/reset-password',
    name: routeNames.ResetPassword,
    meta: { title: 'common.route.resetPassword' },
    component: () => import('@/views/ResetPasswordView.vue'),
  },
  {
    path: '/verify-email',
    name: routeNames.VerifyEmail,
    meta: { title: 'common.route.verifyEmail' },
    component: () => import('@/views/VerifyEmailView.vue'),
  },
  {
    path: '/confirm-email-change',
    name: routeNames.ConfirmEmailChange,
    meta: { title: 'common.route.confirmEmailChange' },
    component: () => import('@/views/ConfirmEmailChangeView.vue'),
  },
]
